import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_3 = { class: "d-flex align-items-start" }
const _hoisted_4 = {
  class: "nav flex-column nav-pills me-3",
  id: "v-pills-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "tab-content flex-grow-1",
  id: "v-pills-tabContent"
}
const _hoisted_7 = { class: "table table-hover table-v2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, " ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_SnippetOverviewItem = _resolveComponent("SnippetOverviewItem")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('snippets'),
        mb: 4,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent
      }, {
        buttons: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: {name: 'new-snippet'},
              class: "btn btn-hover icon-link"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionsInUse, (slotPosition) => {
            return (_openBlock(), _createElementBlock("button", {
              key: slotPosition,
              type: "button",
              onClick: ($event: any) => (_ctx.showTab(slotPosition.code)),
              class: _normalizeClass(["nav-link text-start", {
            'active': _ctx.activeTab === slotPosition.code,
          }])
            }, _toDisplayString(slotPosition.description), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionsInUse, (slotPosition) => {
            return (_openBlock(), _createElementBlock("div", {
              key: slotPosition,
              class: _normalizeClass(["tab-pane fade", {
            'show': _ctx.activeTab === slotPosition.code,
            'active': _ctx.activeTab === slotPosition.code,
          }])
            }, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_8,
                    _createElementVNode("th", null, _toDisplayString(slotPosition.description), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('context')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('created')), 1),
                    _hoisted_9
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSnippetsInSlots, (snippetInSlot) => {
                    return (_openBlock(), _createBlock(_component_SnippetOverviewItem, {
                      snippet: snippetInSlot,
                      key: snippetInSlot.id,
                      onCopy: _ctx.copySnippet,
                      onDelete: _ctx.deleteSnippet,
                      onUpdateStatus: _ctx.updateStatus
                    }, null, 8, ["snippet", "onCopy", "onDelete", "onUpdateStatus"]))
                  }), 128))
                ])
              ])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}